module.exports = __webpack_public_path__ + "static/img/weixin_coder1.f4a8187.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin_coder1.png
// module id = w+Cl
// module chunks = 5